import styled from 'styled-components';
import { responsiveBreakPoints } from '@styles/DesignVariables';
const { maxSmallDesktop } = responsiveBreakPoints;

export const ProductImageWrapper = styled.div`
	display: flex;
	margin: 0 auto;
	justify-content: center;
    align-items: center;
	max-width: 168px;
	height: auto;
	@media only screen and ${maxSmallDesktop} {
		max-width: 120px;
		max-height: 120px;
		margin: 0 0;
	}
	img {
		width: 100%;
		height: auto;
	}
`;
